<!-- <div class="gandalf">
  <div class="fireball"></div>
  <div class="skirt"></div>
  <div class="sleeves"></div>
  <div class="shoulders">
    <div class="hand left"></div>
    <div class="hand right"></div>
  </div>
  <div class="head">
    <div class="hair"></div>
    <div class="beard"></div>
  </div>
</div>
<div class="message">
  <h1>403 - You Shall Not Pass</h1>
  <p>
    Uh oh, Gandalf is blocking the way!<br />Maybe you have a typo in the url?
    Or you meant to go to a different location? Like...Hobbiton?
  </p>
</div> -->

<div class="container-fluid vh-100 dg-bg-primary" *ngIf="false">
  <div class="message">You are not authorized to access this application.</div>
  <!--  <div class="message2">
    You tried to access a page you did not have prior authorization for.
  </div> -->
  <div class="box-container">
    <div class="neon">403</div>
    <div class="door-frame">
      <div class="door">
        <div class="rectangle"></div>
        <div class="handle"></div>
        <div class="window">
          <div class="eye"></div>
          <div class="eye eye2"></div>
          <div class="leaf"></div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid vh-100">
  <div class="row">
    <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-xs-12 top-error">
      <p class="txt-size">ERROR 403</p>
      <br />
      <p class="dg-h-22">You are not authorized to access this application.</p>
    </div>

    <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-xs-12 px-0">
      <!-- <meta
        name="viewport"
        content="width=device-width,height=device-height,initial-scale=1.0"
      /> -->
      <div class="flexbox-centering text-center">
        <!-- <img
          class="viewport-sizing"
          src="./assets/illustrations/Error 404 Illustration (2).svg"
          alt="img"
        /> -->
        <svg
          class="w-100"
          xmlns="http://www.w3.org/2000/svg"
          width="1640"
          height="350"
          viewBox="0 0 1640 350"
          *ngIf="false"
        >
          <defs>
            <style>
              #Group_5361 {
                animation: pulsecharacter 1s infinite alternate;
              }
              @keyframes pulsecharacter {
                0% {
                  transform: translate(940.232px, 477px);
                }

                100% {
                  transform: translate(940.232px, 501px);
                }
              }
            </style>
          </defs>
          <g
            id="Group_5714"
            data-name="Group 5714"
            transform="translate(-140 -292)"
          >
            <g
              id="Rectangle_990"
              data-name="Rectangle 990"
              transform="translate(140 292)"
              fill="#f5f1fe"
              stroke="#707070"
              stroke-width="1"
            >
              <rect width="1640" height="350" stroke="none" />
              <rect x="0.5" y="0.5" width="1639" height="349" fill="none" />
            </g>
            <g
              id="Group_5462"
              data-name="Group 5462"
              transform="translate(-66.137 -89.038)"
            >
              <g
                id="Group_5460"
                data-name="Group 5460"
                transform="translate(816.022 398.071)"
              >
                <g
                  id="Group_5459"
                  data-name="Group 5459"
                  transform="matrix(0.978, 0.208, -0.208, 0.978, 50.965, 0)"
                >
                  <path
                    id="Path_598"
                    data-name="Path 598"
                    d="M173.3,18.88C131.186-11.383,66.883-5.791,28.086,31.509s-38.056,92.817,1.673,125.375,104.078,30.38,145.319-4.918l106.625,85.3c.271.2,86.07-9.229,86.07-9.229l-179.9-89.113c32.006-39.08,25.69-91.1-14.574-120.039ZM161.584,130.651c-28.733,29.292-78.171,34.25-110.424,11.074s-35.107-65.709-6.374-95,78.171-34.249,110.424-11.074h0C187.462,58.827,190.316,101.36,161.584,130.651Z"
                    transform="translate(0 0)"
                    fill="#cfcbbf"
                  />
                </g>
                <path
                  id="Path_1655"
                  data-name="Path 1655"
                  d="M88.3.633C138.442,2.319,180.454,39.6,182.14,83.9s-37.593,78.843-87.732,77.157S2.258,122.089.572,77.79,38.165-1.053,88.3.633Z"
                  transform="matrix(0.966, -0.259, 0.259, 0.966, 24.074, 55.09)"
                  fill="#f9f8f4"
                />
                <path
                  id="Path_1656"
                  data-name="Path 1656"
                  d="M41.2,108.856C2.406,84.024-7.2,33.912,23.864.365c-1.949,1.538,1.827-1.675,0,0C-12.6,33.913-6.743,85.68,34.418,112.027c29.554,18.917,58.651,21.177,93.113,8.448,13.093-4.835,23.508-13.435,33.792-22.9,1.823-1.678-1.619,1.75,0,0-37.432,29.473-81.333,36.1-120.126,11.276Z"
                  transform="matrix(0.978, 0.208, -0.208, 0.978, 47.94, 46.193)"
                  fill="#2b0101"
                  opacity="0.34"
                />
              </g>
              <path
                id="_Light_Theme_1._Headline_H6"
                data-name="🌕 Light Theme/1. Headline/H6"
                d="M38.36,9.474q3.741,0,5.451,1.685a6.293,6.293,0,0,1,1.71,4.7,7.943,7.943,0,0,1-.708,3.339,5.61,5.61,0,0,1-2.365,2.519,8.881,8.881,0,0,1-4.489.969H35.9v8.08H33.016V9.474Zm-.214,2.713H35.9v7.782h1.737a6.187,6.187,0,0,0,3.674-.909,3.572,3.572,0,0,0,1.242-3.086,3.592,3.592,0,0,0-1.069-2.847A4.971,4.971,0,0,0,38.146,12.187ZM60.122,30.763l-2.031-6.142H50.717l-2.031,6.142H45.694L52.935,9.385h2.993l7.214,21.378ZM57.29,21.818l-1.924-5.993q-.107-.328-.294-.984T54.7,13.47q-.187-.716-.294-1.163-.214.924-.481,1.968t-.428,1.55l-1.924,5.993Zm16.045-2.5h6.894V29.928a17.935,17.935,0,0,1-3.113.85,20.787,20.787,0,0,1-3.62.283,8.14,8.14,0,0,1-6.72-2.892q-2.338-2.892-2.338-8.05a13.454,13.454,0,0,1,1.162-5.8,8.637,8.637,0,0,1,3.38-3.8,10.189,10.189,0,0,1,5.371-1.342,12.5,12.5,0,0,1,3.019.358,14.987,14.987,0,0,1,2.672.924L79,13.142a11.807,11.807,0,0,0-2.218-.85,9.4,9.4,0,0,0-2.538-.343,6.542,6.542,0,0,0-3.647,1A6.346,6.346,0,0,0,68.245,15.8a10.723,10.723,0,0,0-.815,4.353,12.419,12.419,0,0,0,.668,4.234,5.958,5.958,0,0,0,2.111,2.892,6.281,6.281,0,0,0,3.767,1.044,11.8,11.8,0,0,0,1.937-.134q.788-.134,1.456-.313V22.086H73.335Zm22.4,11.449H85V9.474H95.739v2.743H87.884V18.3h7.375v2.713H87.884V27.99h7.855ZM49.822,74.341h-3.5l-9.646-17.2h-.107q.053,1.193.12,2.728t.094,3.146v11.33H34.165V53.052h3.473l9.619,17.115h.08q-.027-.626-.067-1.58T47.2,66.544q-.027-1.088-.053-2.042V53.052h2.672Zm40.279,0H87.216V55.825H81.5V53.052H95.819v2.773H90.1ZM21.346,117.918H18.487V96.629H29.228v2.743H21.346v6.947h7.375v2.743H21.346Zm28.282-10.674a15.415,15.415,0,0,1-.989,5.769,8.282,8.282,0,0,1-2.966,3.831,8.42,8.42,0,0,1-4.916,1.372,8.567,8.567,0,0,1-5-1.372A8.114,8.114,0,0,1,32.822,113a15.919,15.919,0,0,1-.962-5.784,15.707,15.707,0,0,1,.962-5.74,8.032,8.032,0,0,1,2.939-3.816A8.686,8.686,0,0,1,40.784,96.3a8.425,8.425,0,0,1,4.9,1.357,8.223,8.223,0,0,1,2.952,3.816A15.415,15.415,0,0,1,49.629,107.244Zm-14.722,0a11.068,11.068,0,0,0,1.416,6.023,4.89,4.89,0,0,0,4.435,2.206,4.852,4.852,0,0,0,4.435-2.206,11.238,11.238,0,0,0,1.389-6.023,11.078,11.078,0,0,0-1.389-5.993,4.846,4.846,0,0,0-4.409-2.177,4.938,4.938,0,0,0-4.462,2.177A10.912,10.912,0,0,0,34.906,107.244ZM68.773,96.629V110.4a9.427,9.427,0,0,1-.815,3.98,6.3,6.3,0,0,1-2.5,2.8,8.026,8.026,0,0,1-4.248,1.029,6.924,6.924,0,0,1-5.518-2.162,8.38,8.38,0,0,1-1.884-5.71V96.629H56.7V110.2q0,5.277,4.649,5.277a4.09,4.09,0,0,0,3.487-1.431,6.281,6.281,0,0,0,1.082-3.876V96.629Zm20.774,21.289h-3.5l-9.646-17.2h-.107q.053,1.193.12,2.728t.094,3.146v11.33H73.89V96.629h3.473l9.619,17.115h.08q-.027-.626-.067-1.58t-.067-2.042q-.027-1.088-.053-2.042V96.629h2.672Zm20.721-10.853q0,5.4-2.659,8.125a9.912,9.912,0,0,1-7.441,2.728H94.824V96.629h5.9a10.2,10.2,0,0,1,5.05,1.193,8.089,8.089,0,0,1,3.313,3.518A12.6,12.6,0,0,1,110.268,107.065Zm-3.019.089q0-4.025-1.737-5.919a6.405,6.405,0,0,0-4.97-1.893H97.71V115.2h2.325Q107.249,115.2,107.249,107.155Z"
                transform="translate(888.984 438.16)"
              />
              <g
                id="Group_5461"
                data-name="Group 5461"
                transform="translate(952.894 553.37)"
              >
                <g
                  id="Group_5390"
                  data-name="Group 5390"
                  transform="translate(0 0)"
                >
                  <path
                    id="Path_688"
                    data-name="Path 688"
                    d="M507.431,563.223,490,562.4l5.809,18.616,19.75-5.792Z"
                    transform="translate(-458.016 -412.114)"
                    fill="#fbb1b1"
                  />
                  <path
                    id="Path_689"
                    data-name="Path 689"
                    d="M695.76,471.8,655.1,438.3l-23.236,15.274-45.891,46.808,5.228,6.9,55.766-32.026,37.757,41.881,36.015-15.275Z"
                    transform="translate(-486.823 -362.13)"
                    fill="#303030"
                  />
                  <path
                    id="Path_690"
                    data-name="Path 690"
                    d="M795.2,655l-5.228,3.449-42.405-12.318-9.875-3.449-19.751,3.449s0-13.8,18.589-13.3l19.17,3.942,22.655,1.478Z"
                    transform="translate(-582.773 -523.154)"
                    fill="#fbb1b1"
                  />
                  <path
                    id="Path_691"
                    data-name="Path 691"
                    d="M714.58,556.871l-12.78,6.9H686.7L616.409,541.6,513.591,557.364l-2.9-18.723,94.105-34.983,82.487,23.158Z"
                    transform="translate(-465.919 -388.069)"
                    fill="#303030"
                  />
                  <path
                    id="Path_695"
                    data-name="Path 695"
                    d="M555.828,690.44s4.653-6.109,2.688-6.822-10.312-3.557-10.312-3.557l-12.241-3.142s-17.662-20.334-18.05-2.651,12.86,21.933,12.86,21.933,11.816,19.7,18.509,16.556,13.39-13.8,13.39-13.8S550.6,693.928,555.828,690.44Z"
                    transform="translate(-517.905 -535.708)"
                    fill="#303030"
                  />
                  <g
                    id="Group_5161"
                    data-name="Group 5161"
                    transform="translate(145.38 0)"
                  >
                    <path
                      id="Path_692"
                      data-name="Path 692"
                      d="M759.5,551.487l-9.321,1.472-2.031-1.871c-3.288-3.028-3.957-7.317-1.7-10.884h0l26.1-26.982s7.457-13.246,19.264-7.849-9.943,14.227-9.943,14.227l-13.05,16.189,1.243,8.34Z"
                      transform="translate(-745.128 -471.233)"
                      fill="#fbb1b1"
                    />
                    <ellipse
                      id="Ellipse_102"
                      data-name="Ellipse 102"
                      cx="24.235"
                      cy="19.132"
                      rx="24.235"
                      ry="19.132"
                      transform="translate(49.174 10.1)"
                      fill="#fbb1b1"
                    />
                    <path
                      id="Path_693"
                      data-name="Path 693"
                      d="M828.382,518.176l11.185,21.095,26.721-8.83s-8.7-16.68-8.7-17.17S828.382,518.176,828.382,518.176Z"
                      transform="translate(-765.847 -474.962)"
                      fill="#fbb1b1"
                    />
                    <path
                      id="Path_694"
                      data-name="Path 694"
                      d="M884.978,589.962a89.019,89.019,0,0,1-6.828,34l-1.815,4.408-8.7,31.4-9.321,1.962-6.836-6.868-13.671-7.849-9.943-12.755-8.526-11.214-2.66-3.5-9.321-36.793-35.421-15.7-11.807-1.472,2.486-5.4L773.18,548.9l10.564-.981,3.107-1.962,2.485.981,9.943-4.415,3.107.981,18.17,1.334,11.036-1.825,15.871-6.726,6.5.839,22.371,14.718A89.532,89.532,0,0,1,884.978,589.962Z"
                      transform="translate(-748.862 -484.341)"
                      fill="#928dc4"
                    />
                    <path
                      id="Path_696"
                      data-name="Path 696"
                      d="M816.624,474.779l-24.583,17.275-36.694,35.34-2.769-4.934L744.814,481h1.941l20.055-39.388Z"
                      transform="translate(-688.506 -381.974)"
                      opacity="0.1"
                    />
                    <path
                      id="Path_697"
                      data-name="Path 697"
                      d="M760.653,436.645,740.868,473.6h-7.02l-4.468,12.968-10.212,2.593,27.444,30.473,38.932-35.66L809.8,467.767Z"
                      transform="translate(-681.679 -377.038)"
                      fill="#928dc4"
                    />
                    <path
                      id="Path_698"
                      data-name="Path 698"
                      d="M814.977,463.7l-2.626.8a2.94,2.94,0,0,1-1.551-1.878,2.429,2.429,0,0,1,.614-2.189l-4.852-.179c6.3-6.625,15.9-10.8,26.358-11.465s20.78,2.241,28.343,7.984c.221-.6,2.629.568,3.612,1.753.33-.977,2.588,3.748,3.387,7.088.37-1.112,1.792.683.546,2.406.789-.091,1.146,1.5.535,2.391.863-.32.718,1.583-.218,2.854,1.232-.086-9.716,13.328-14.149,21.167-1.287-4.669-2.734-9.585-6.885-13.063-.705-.591-1.478-1.13-2.249-1.667l-4.172-2.907c-4.851-3.38-9.263-7.552-15.725-8.816-4.441-.868-7.249-1.064-4.829-5.015-2.187.72-4.228,1.792-6.434,2.461A14.308,14.308,0,0,0,814.977,463.7Z"
                      transform="translate(-760.417 -448.688)"
                      fill="#231813"
                    />
                    <ellipse
                      id="Ellipse_103"
                      data-name="Ellipse 103"
                      cx="5.132"
                      cy="4.949"
                      rx="5.132"
                      ry="4.949"
                      transform="translate(75.733 25.834)"
                      fill="#fbb1b1"
                    />
                  </g>
                </g>
              </g>
              <g
                id="Group_5361"
                data-name="Group 5361"
                transform="translate(940.232 489)"
              >
                <path
                  id="Path_1599"
                  data-name="Path 1599"
                  d="M6.065.082c3.353.055,6.083.891,6.1,1.867S9.475,3.672,6.123,3.616.04,2.726.024,1.75,2.713.027,6.065.082Z"
                  transform="matrix(0.669, -0.743, 0.743, 0.669, 20.798, 16.914)"
                  fill="#2f2e41"
                />
                <g
                  id="Group_5150"
                  data-name="Group 5150"
                  transform="translate(0 0)"
                >
                  <g
                    id="Group_5149"
                    data-name="Group 5149"
                    transform="translate(7.15 0)"
                  >
                    <g
                      id="Group_5147"
                      data-name="Group 5147"
                      transform="translate(5.198 21.743)"
                    >
                      <rect
                        id="Rectangle_871"
                        data-name="Rectangle 871"
                        width="2.901"
                        height="4.64"
                        transform="translate(0 0)"
                        fill="#2f2e41"
                      />
                      <rect
                        id="Rectangle_872"
                        data-name="Rectangle 872"
                        width="2.901"
                        height="4.64"
                        transform="translate(5.803 0)"
                        fill="#2f2e41"
                      />
                      <ellipse
                        id="Ellipse_113"
                        data-name="Ellipse 113"
                        cx="2.418"
                        cy="0.809"
                        rx="2.418"
                        ry="0.809"
                        transform="translate(0 3.885)"
                        fill="#2f2e41"
                      />
                      <ellipse
                        id="Ellipse_114"
                        data-name="Ellipse 114"
                        cx="2.418"
                        cy="0.809"
                        rx="2.418"
                        ry="0.809"
                        transform="translate(5.803 3.777)"
                        fill="#2f2e41"
                      />
                    </g>
                    <g
                      id="Group_5146"
                      data-name="Group 5146"
                      transform="translate(0)"
                    >
                      <g
                        id="Group_5145"
                        data-name="Group 5145"
                        transform="translate(0)"
                      >
                        <g
                          id="Group_5144"
                          data-name="Group 5144"
                          transform="translate(0 6.528)"
                        >
                          <ellipse
                            id="Ellipse_112"
                            data-name="Ellipse 112"
                            cx="9.55"
                            cy="8.524"
                            rx="9.55"
                            ry="8.524"
                            fill="#2f2e41"
                          />
                          <g
                            id="Group_5143"
                            data-name="Group 5143"
                            transform="translate(6.528 3.453)"
                          >
                            <ellipse
                              id="Ellipse_115"
                              data-name="Ellipse 115"
                              cx="3.264"
                              cy="2.913"
                              rx="3.264"
                              ry="2.913"
                              fill="#fff"
                            />
                            <ellipse
                              id="Ellipse_116"
                              data-name="Ellipse 116"
                              cx="1.088"
                              cy="0.971"
                              rx="1.088"
                              ry="0.971"
                              transform="translate(2.176 1.942)"
                              fill="#3f3d56"
                            />
                          </g>
                        </g>
                        <path
                          id="Path_798"
                          data-name="Path 798"
                          d="M201.541,478.059c-.771-3.083,1.694-6.2,5.506-6.957s7.527,1.123,8.3,4.206-1.755,4.219-5.567,4.979S202.312,481.142,201.541,478.059Z"
                          transform="translate(-201.255 -470.934)"
                          fill="#928dc4"
                        />
                      </g>
                      <path
                        id="Path_805"
                        data-name="Path 805"
                        d="M415.814,524.414c0,1.052-2.1-.157-4.311-.157s-4.394,1.169-4.394.117c0-.6.711-1.434,1.732-2.04h0a5.342,5.342,0,0,1,2.662-.784,5.128,5.128,0,0,1,2.693.84A3.09,3.09,0,0,1,415.814,524.414Z"
                        transform="translate(-401.971 -504.075)"
                        fill="#fcfcfc"
                      />
                    </g>
                  </g>
                  <path
                    id="Path_1600"
                    data-name="Path 1600"
                    d="M1.647.018c.918.012,1.7,3.188,1.752,7.094s-.655,7.063-1.573,7.051S.124,10.974.074,7.068.729.006,1.647.018Z"
                    transform="translate(0 12.602) rotate(-64.626)"
                    fill="#2f2e41"
                  />
                </g>
              </g>
            </g>
          </g>
        </svg>
        <mat-icon class="dg-txt-primary h-auto w-auto lock-font">lock</mat-icon>
      </div>
    </div>
    <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-xs-12 bottom-error">
      <button
        class="btn-back"
        mat-raised-button
        color="primary"
        (click)="onBack()"
      >
        <mat-icon class="back-icon"> keyboard_backspace </mat-icon>
        <span class="btn-txt-back"> Go Back</span>
      </button>
    </div>
  </div>
</div>

<ng-template *ngIf="false">
  <div class="h-100 w-100"></div>
  <div class="lock"></div>
  <div class="message dg-txt-primary">
    <h1>Access to this page is restricted</h1>
    <p>Please check with the site admin if you believe this is a mistake.</p>
  </div>
</ng-template>
